import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { DeleteButton } from "@refinedev/mui";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { useDateOptions } from "@shared/options";
import { TableCell, ModalRef } from "@shared/components";

export const useBookMonthListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  editModalRef: React.RefObject<ModalRef>,
): GridColDef[] => {
  const { getMonthOptions } = useDateOptions();
  const monthOptions = getMonthOptions();

  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("v2/bookstore/book_month_admin.fields.id"),
        width: 80,
      },
      {
        field: "month",
        headerName: translate("v2/bookstore/book_month_admin.fields.month"),
        minWidth: 150,
        headerAlign: "center",
        renderCell: ({ value }) => {
          const label = monthOptions.find((o) => String(o.value) === String(value))?.label ?? value;
          return <TableCell.Text value={label} align="center" />;
        },
      },
      {
        field: "year",
        headerName: translate("v2/bookstore/book_month_admin.fields.year"),
        minWidth: 100,
        headerAlign: "center",
        renderCell: ({ value }) => <TableCell.Text value={value} align="center" />,
      },
      {
        field: "created_at",
        headerName: translate("v2/bookstore/book_month_admin.fields.created_at"),
        minWidth: 180,
        headerAlign: "center",
        renderCell: ({ value }) => <TableCell.Date value={value} align="center" />,
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <IconButton size="small" onClick={() => editModalRef.current?.open(row.id)}>
              <EditIcon fontSize="small" />
            </IconButton>
            <DeleteButton hideText recordItemId={row.id} onSuccess={onRefetch} />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, monthOptions, editModalRef],
  );
};
